// Normalize a single dropdown/multi_select option into the canonical
// shape { id, label, color, position }. Tolerates three legacy shapes:
//   - bare string ('To do')
//   - { value, label } (older config)
//   - { id, label, color, position } (canonical; passes through)
const DEFAULT_OPTION_COLOR = '#94a3b8';

function slugifyLabel(label) {
  return String(label || '').trim().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'opt';
}

export function normalizeOption(raw, index) {
  if (raw == null) return null;
  if (typeof raw === 'string') {
    return { id: slugifyLabel(raw) || `opt-${index}`, label: raw, color: DEFAULT_OPTION_COLOR, position: index };
  }
  const id = raw.id != null ? String(raw.id) : (raw.value != null ? String(raw.value) : slugifyLabel(raw.label || '') || `opt-${index}`);
  const label = raw.label != null ? String(raw.label) : (raw.value != null ? String(raw.value) : '');
  const color = raw.color || DEFAULT_OPTION_COLOR;
  const position = Number.isFinite(raw.position) ? raw.position : index;
  return { id, label, color, position };
}

// Normalize an options array and sort by position. Always returns a new array.
export function normalizeOptions(rawOptions) {
  if (!Array.isArray(rawOptions)) return [];
  return rawOptions
    .map((raw, i) => normalizeOption(raw, i))
    .filter(Boolean)
    .sort((a, b) => a.position - b.position);
}

// Find an option in a normalized list by id OR legacy value match.
export function findOption(options, value) {
  if (value == null) return null;
  const v = String(value);
  return options.find((o) => o.id === v || o.label === v) || null;
}

export { DEFAULT_OPTION_COLOR };
